import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9, default as _styled10, default as _styled11 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { cloneObjectWithPrefixedProperties, getProductImageURL } from '@noths/polaris-client-utils';
import { FREE_UK_DELIVERY } from "../constants/copy";
import * as styles from "../styles";
import { PrimaryLabel } from "../../../../elements/Labels/PrimaryLabel/PrimaryLabel";
import { Price } from "../../../../elements/Price/Price";
import { IconLocalShippingLocal } from "../../../../foundations/Iconography/IconLocalShippingLocal";
import { Image } from "../../../../foundations/Image/Image";
import * as imageStyles from "../../../../../styles/image";
export var CAROUSEL_PRODUCT_PRICE = 'carousel-product-price';
export var CAROUSEL_PRODUCT_PREVIOUS_PRICE = 'carousel-product-price';
export var CarouselProductCard = function CarouselProductCard(_ref) {
  var alt = _ref.alt,
    currency = _ref.currency,
    _ref$enableFreeDomest = _ref.enableFreeDomesticDeliveryLabels,
    enableFreeDomesticDeliveryLabels = _ref$enableFreeDomest === void 0 ? false : _ref$enableFreeDomest,
    freeDomesticDelivery = _ref.freeDomesticDelivery,
    _ref$hideLabelIcons = _ref.hideLabelIcons,
    hideLabelIcons = _ref$hideLabelIcons === void 0 ? false : _ref$hideLabelIcons,
    href = _ref.href,
    _ref$imageLoading = _ref.imageLoading,
    imageLoading = _ref$imageLoading === void 0 ? 'lazy' : _ref$imageLoading,
    isNew = _ref.isNew,
    _ref$linkDataAttribut = _ref.linkDataAttributes,
    linkDataAttributes = _ref$linkDataAttribut === void 0 ? {} : _ref$linkDataAttribut,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    _ref$onLinkClick = _ref.onLinkClick,
    onLinkClick = _ref$onLinkClick === void 0 ? function () {} : _ref$onLinkClick,
    preSalePrice = _ref.preSalePrice,
    price = _ref.price,
    purchasable = _ref.purchasable,
    _ref$salePercentage = _ref.salePercentage,
    salePercentage = _ref$salePercentage === void 0 ? 0 : _ref$salePercentage,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'regular' : _ref$size,
    src = _ref.src,
    title = _ref.title;
  var linkDataProps = cloneObjectWithPrefixedProperties(linkDataAttributes, 'data-');
  return /*#__PURE__*/React.createElement(_StyledA, _extends({
    href: href,
    onBlur: onBlur,
    onClick: onLinkClick,
    onFocus: onFocus
  }, linkDataProps, {
    $_css: [imageStyles.imageWidth[size], styles.product]
  }), /*#__PURE__*/React.createElement(_StyledH, {
    $_css2: styles.productHeading
  }, /*#__PURE__*/React.createElement(_StyledImage, {
    alt: alt,
    loading: imageLoading,
    src: getProductImageURL(src, 'normal'),
    $_css3: [imageStyles.image[size], styles.fitImageToContainer]
  }), /*#__PURE__*/React.createElement(_StyledP, {
    $_css4: styles.productTitle
  }, title)), /*#__PURE__*/React.createElement(_StyledPrimaryLabel, {
    className: "similar-product-image__label",
    hasStock: purchasable,
    isNew: isNew,
    salePercentage: salePercentage !== null && salePercentage !== void 0 ? salePercentage : undefined,
    $_css5: styles.productLabel
  }), /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css6: styles.productPrices
  }, price && /*#__PURE__*/React.createElement(_StyledPrice, {
    amount: price,
    currency: currency,
    testId: CAROUSEL_PRODUCT_PRICE,
    type: preSalePrice !== undefined ? 'sale' : 'normal',
    $_css7: styles.productPrice
  }), preSalePrice && /*#__PURE__*/React.createElement(_StyledPrice2, {
    amount: preSalePrice,
    currency: currency,
    testId: CAROUSEL_PRODUCT_PREVIOUS_PRICE,
    type: "previous",
    $_css8: styles.productPreviousPrice
  })), enableFreeDomesticDeliveryLabels && freeDomesticDelivery && /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css9: styles.freeDeliveryLabelWrapper
  }, /*#__PURE__*/React.createElement(_StyledSpan, {
    $_css10: styles.freeDelivery
  }, !hideLabelIcons && /*#__PURE__*/React.createElement(_StyledIconLocalShippingLocal, {
    height: 16,
    width: 16,
    $_css11: styles.freeDeliveryIcon
  }), FREE_UK_DELIVERY)));
};
var _StyledA = _styled("a")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledH = _styled2("h3")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledImage = _styled3(Image)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledP = _styled4("p")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledPrimaryLabel = _styled5(PrimaryLabel)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css5;
});
var _StyledDiv = _styled6("div")(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css6;
});
var _StyledPrice = _styled7(Price)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css7;
});
var _StyledPrice2 = _styled8(Price)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css8;
});
var _StyledDiv2 = _styled9("div")(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css9;
});
var _StyledSpan = _styled10("span")(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css10;
});
var _StyledIconLocalShippingLocal = /*#__PURE__*/_styled11(IconLocalShippingLocal).withConfig({
  displayName: "CarouselProductCard___StyledIconLocalShippingLocal",
  componentId: "sc-1cekv77-0"
})(["", ""], function (p) {
  return p.$_css11;
});